var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBahrainsmlogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1018_25317)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1018_25317)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "#F93939"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0.5H7.33333V16.5H0V0.5ZM7.33333 0.5L9.42857 2.1L7.33333 3.7V0.5ZM7.33333 3.7L9.42857 5.3L7.33333 6.9V3.7ZM7.33333 6.9L9.42857 8.5L7.33333 10.1V6.9ZM7.33333 10.1L9.42857 11.7L7.33333 13.3V10.1ZM7.33333 13.3L9.42857 14.9L7.33333 16.5V13.3Z",
    fill: "white"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 21,
    height: 15,
    rx: 2.5,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1018_25317"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1018_25317"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBahrainsmlogo);
export default __webpack_public_path__ + "static/media/bahrainsmlogo.dcac45ecb895e0015cf39d76c2a6ed2c.svg";
export { ForwardRef as ReactComponent };